import {
  Bot, CalendarCheck, Search, MapPin, Zap, Star, Workflow, Share2, PenLine, TrendingUp, Palette, Camera,
} from "lucide-react";

export const BUILDS = [
  { id: "standard", label: "Standard", price: 500, detail: "5 pages · mobile-first · basic SEO" },
  { id: "plus", label: "Plus", price: 750, detail: "More pages · booking · blog" },
  { id: "premium", label: "Premium", price: 1000, detail: "E-commerce · advanced" },
  { id: "custom", label: "Custom", price: null, detail: "Bespoke · we quote" },
];

export const PLANS = [
  { id: "essential", label: "Essential", price: 100, detail: "Hosting · security · backups · 1hr changes" },
  { id: "growth", label: "Growth", price: 200, detail: "+ Local SEO · Google Business · unlimited changes", recommended: true },
  { id: "complete", label: "Complete", price: 300, detail: "+ AI automations · social · monthly refresh" },
];

export const FEATURES = [
  { id: "ai_chatbot", label: "AI Chatbot", price: 200, monthly: 30, icon: Bot },
  { id: "online_booking", label: "Online Booking", price: 150, icon: CalendarCheck },
  { id: "local_seo", label: "Local SEO", price: 150, monthly: 50, icon: Search },
  { id: "google_business", label: "Google Business Profile", price: 100, icon: MapPin },
  { id: "ai_lead_capture", label: "AI Lead Capture", price: 150, icon: Zap },
  { id: "reviews", label: "Review Generation", price: 50, monthly: 10, icon: Star },
  { id: "ai_workflow", label: "AI Workflow Automation", price: 400, icon: Workflow },
  { id: "social_media", label: "Social Media", price: 100, monthly: 50, icon: Share2 },
  { id: "content_writing", label: "Content Writing", price: 50, unit: "/page", icon: PenLine },
  { id: "scalability", label: "Scalability Review", price: 100, icon: TrendingUp },
  { id: "branding", label: "Branding", price: 150, icon: Palette },
  { id: "photography", label: "Photography", price: 150, icon: Camera },
];

export const gbp = (n) => `£${n.toLocaleString("en-GB")}`;

export const computeTotals = (buildId, planId, featureIds) => {
  const build = BUILDS.find((b) => b.id === buildId);
  const plan = PLANS.find((p) => p.id === planId);
  const picked = FEATURES.filter((f) => featureIds.includes(f.id));
  const oneOff = (build.price || 0) + picked.reduce((s, f) => s + f.price, 0);
  const monthly = plan.price + picked.reduce((s, f) => s + (f.monthly || 0), 0);
  return { build, plan, picked, oneOff, monthly, isQuote: build.price === null };
};
